import { useContext, useEffect, forwardRef } from 'react';
import noop from 'lodash/noop';

import { PopOutAudioContext } from '../../pop-out-audio';

import { AudioListItem } from '../audio-list-item/audio-list-item';
import type { AudioItem } from '../../types';
import { PlayStates } from '../../../pop-out-media-manager/types';

type AudioListProps = {
  audios: Array<AudioItem>;
  onAudioItemClicked?: (itemId: string) => void;
  addToProvider: boolean;
};

export const AudioList = forwardRef<HTMLLIElement, AudioListProps>(
  (
    { audios, onAudioItemClicked = noop, addToProvider }: AudioListProps,
    ref,
  ) => {
    const { addAudio, toggleAudioState, getCurrentlyActive } =
      useContext(PopOutAudioContext);

    const {
      itemId,
      state: { playState: audioPlayState },
    } = getCurrentlyActive() || { state: {}, itemId: '' };

    useEffect(() => {
      if (addToProvider) {
        addAudio(audios);
      }
    }, [audios]);

    return (
      <ul>
        {audios.map(audio => {
          const { itemId: audioItemId, title, subtitle, srcUrl } = audio;

          const isActive = itemId === audioItemId;
          const isPlaying = isActive && audioPlayState === PlayStates.Playing;
          const listItemProps = isPlaying ? { ref } : {};
          return (
            <li {...listItemProps} key={audioItemId}>
              <AudioListItem
                playing={isPlaying}
                title={title}
                subtitle={subtitle}
                audioSrc={srcUrl}
                onClick={() => {
                  toggleAudioState(audioItemId);
                  onAudioItemClicked(audioItemId);
                }}
              />
            </li>
          );
        })}
      </ul>
    );
  },
);
